import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api';

interface MatrixEntry {
  id: string;
  name: string;
  email: string | null;
  seniority: string | null;
  location: string | null;
  skillsByCategory: Record<string, string[]>;
  totalSkills: number;
}

export function useCompetenceMatrix() {
  return useQuery({
    queryKey: ['competence-matrix'],
    queryFn: () => apiFetch<MatrixEntry[]>('/admin/competence-matrix')
  });
}

export type { MatrixEntry };
